import {
  systemContext,
  teamContext,
  userEmailContext,
} from "@redotech/feature-flags-model/context";
import { featureFlag } from "@redotech/openfeature-contracts/flag";

/** Gate agent return-window settings, exceptions and their origin filter. */
export const agentReturnWindowExceptionsFlag = featureFlag(
  "agent-return-window-exceptions",
  teamContext,
).boolean(false);

/** Rollout and kill switch for the customs readiness popup. */
export const customsReadinessPopupFlag = featureFlag(
  "customs-readiness-popup",
  teamContext,
).boolean(false);

/** Item outcomes card in managed returns settings. */
export const inventoryItemOutcomesFlag = featureFlag(
  "inventory-item-outcomes",
  teamContext,
).boolean(false);

/** Merchants may process a Redo-managed PP+ claim before the insurer decides. */
export const ppPlusProcessBeforeInsurerDecisionFlag = featureFlag(
  "pp-plus-process-before-insurer-decision",
  teamContext,
).boolean(false);

/** Show the RedoJS order sync function in returns automation settings. */
export const redojsOrderSyncFlag = featureFlag(
  "redojs-order-sync",
  teamContext,
).boolean(false);

/** Kill switch: purchaseLabel buys and bills from the server's quote, not the request's rate. */
export const purchaseLabelServerQuoteFlag = featureFlag(
  "purchase-label-server-quote",
  systemContext,
).boolean(false);

/** Per-user (Redo employee email) gate for the request-additional-claim-documents action. */
export const requestAdditionalClaimDocumentsFlag = featureFlag(
  "request-additional-claim-documents",
  userEmailContext,
).boolean(false);

/** Show the redesigned return details page. */
export const returnDetailsV2Flag = featureFlag(
  "return-details-v2",
  teamContext,
).boolean(false);

/**
 * Redo users skip the invite and start in the new returns experience on this
 * team, and can still switch. Turn it off for a team to opt the team out.
 */
export const returnDetailsV2RedoUsersFlag = featureFlag(
  "return-details-v2-redo-users",
  teamContext,
).boolean(false);

/** Load the return page's customer orders with the native CockroachDB read instead of Order.find. */
export const returnPageNativeCustomerOrdersFlag = featureFlag(
  "return-page-native-customer-orders",
  teamContext,
).boolean(false);

/** Advanced flow editor for return processing, replacing processing automations. */
export const returnProcessingFlowsFlag = featureFlag(
  "return-processing-flows",
  teamContext,
).boolean(false);

/** Disable the customer portal for teams past the Shopify returns billing acceptance deadline. */
export const shopifyReturnsBillingEnforceFlag = featureFlag(
  "shopify-returns-billing-enforce",
  teamContext,
).boolean(false);

/** Offer advanced exchanges in the return app for Commerce Cloud teams. */
export const sfccAdvancedExchangeFlag = featureFlag(
  "sfcc-advanced-exchange",
  teamContext,
).boolean(false);

/** Show and allow saving the Aptos returns write-back settings (exchange orders, refunds, store credit). */
export const aptosReturnsWriteBackFlag = featureFlag(
  "aptos-returns-write-back",
  teamContext,
).boolean(false);
